import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {

  ngOnInit(): void {
    this.sendPostbackMessage();
  }

  private sendPostbackMessage() {
    window.parent.postMessage({
      status: 'COMPLETED',
      paymethod: 'PAY_JUST_NOW'
    }, `${window.location.protocol}//${window.location.host}`);
  }

}
